import { styled } from "@mui/material";

const Header = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  align-items: flex-start;
`;

const DrawerBody = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 20px 20px 20px;
  row-gap: 12px;
  color: #333333;
`;

export { Header, DrawerBody };
